import { FILTERS_ACTIONS, STATUS } from "../constant";

const initialState = {
  isLoading: STATUS.SUCCESS,
  selectedFilters: {},
  bubbleFilters: [],
  data: {}
};

const excludeFilters = selectedFilters => {
  const filters = [];
  Object.keys(selectedFilters).forEach(key => {
    if (
      ![
        "limit",
        "offset",
        "sortBy",
        "sortOrder",
        "search",
        "createdDate",
        "projectIdFilter",
        "groupCategory"
      ].includes(key)
    ) {
      filters.push({ [key]: selectedFilters[key] });
    }
  });

  return filters;
};

const excludeBasedOnFilteredData = (bubbleFilters, currentFiltersList) => {
  if (
    !currentFiltersList ||
    currentFiltersList.length === 0 ||
    !bubbleFilters
  ) {
    return bubbleFilters;
  }

  for (let i in bubbleFilters) {
    let bubbleFilter = bubbleFilters[i];
    let bubbleKey = Object.keys(bubbleFilter)[0];
    let currentFilter = currentFiltersList[bubbleKey];

    if (!currentFilter) {
      continue;
    }

    let keys = [];
    keys = currentFilter.values.map(filter => filter.key);
    bubbleFilter[bubbleKey] = bubbleFilter[bubbleKey].filter(filter => {
      return keys.includes(filter.key);
    });
  }
  return bubbleFilters;
};

export function issueListReducer(state = initialState, action) {
  try {
    let filter;
    switch (action.type) {
      case FILTERS_ACTIONS._ISSUE_LIST_._START:
        filter = { ...action.payload };
        return {
          ...state,
          isLoading: STATUS.LOADING,
          selectedFilters: filter,
          bubbleFilters: excludeFilters(filter),
          data: {}
        };

      case FILTERS_ACTIONS._ISSUE_LIST_._SUCCESS:
        return {
          ...state,
          isLoading: STATUS.SUCCESS,
          data: action.payload,
          bubbleFilters: excludeBasedOnFilteredData(
            state.bubbleFilters,
            action.payload.filters
          )
        };

      case FILTERS_ACTIONS._ISSUE_LIST_._FAILURE:
        return {
          ...state,
          isLoading: STATUS._FAILURE,
          data: {}
        };

      case FILTERS_ACTIONS._ISSUE_LIST_._CLEAR:
        return {
          ...state,
          selectedFilters: {},
          isLoading: STATUS._FAILURE,
          bubbleFilters: {},
          data: {}
        };

      default:
        return state;
    }
  } catch (error) {
    console.error(error);
  }
}
